// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {FormattedMessage} from 'react-intl';
import WarrantyDateRangePicker from '../../../shared/components/warranty-date-range-picker/warranty-date-range-picker';

const DemoRentalHistoryDatesCriteria = props =>
    <section className='demo-rental-dates'>
        <label className='demo-rental-date-label'>
            <FormattedMessage id={props.label}/>
        </label>
        <WarrantyDateRangePicker
            dateRange={props.dateRange}
            maxDate={props.dateRange.max}
            minDate={props.dateRange.min}
            onDateChange={props.onDateChange}
        />
    </section>;

DemoRentalHistoryDatesCriteria.displayName = 'DemoRentalHistoryDatesCriteria';
DemoRentalHistoryDatesCriteria.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange).isRequired,
    label: PropTypes.string.isRequired,
    onDateChange: PropTypes.func.isRequired
};

export default DemoRentalHistoryDatesCriteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-dates-criteria.js